import { CommonMessages } from "../messages/validationMessages"
import * as Yup from 'yup'
import { EMAIL_REGEX,MIN_PASSWORD_LENGTH } from "../utils/constants"

export const cwoAddnewUserSchema = Yup.object().shape({
    selectlocation: Yup.string().required(CommonMessages.location_required),
    name: Yup.string().required(CommonMessages.name_required),
    emailid: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
    phonenumber: Yup.string().required(CommonMessages.phone_required),
    password1: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
    password2: Yup.string().trim().oneOf([Yup.ref('password1')], CommonMessages.password_match).required(CommonMessages.password_required),
});

export const editcwoAddnewUserSchema = Yup.object().shape({
    selectlocation: Yup.string().required(CommonMessages.location_required),
    name: Yup.string().required(CommonMessages.name_required),
    emailid: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
    phonenumber: Yup.string().required(CommonMessages.phone_required),
});